interface EnvironmentVariables {
    REACT_APP_API_URL: string;
    REACT_APP_BLOB_URL: string;
    REACT_APP_PRESENT_TARGETS_TIME: string;
    REACT_APP_CUED_RECALL_TIME: string;
    REACT_APP_FREE_RECALL_TIME: string;
    REACT_APP_FREE_RECALL_TIMEOUT: string;
    REACT_APP_DELAY_TIME: string;
    REACT_APP_ASSESSMENT_TIMEOUT: string;
    REACT_APP_SHOW_TIMERS: string;
    REACT_APP_SHOW_LOGS: string;
    REACT_APP_STT_BOOST: string;
    REACT_APP_STT_PT_TIMEOUT: string;
    REACT_APP_STT_FR_TIMEOUT: string;
    REACT_APP_STT_CR_TIMEOUT: string;
    REACT_APP_GOOGLE_STT_KEY: string;
    REACT_APP_AZURE_STT_KEY: string;
    REACT_APP_AZURE_STT_REGION: string;
    REACT_APP_B2C_CLIENT_ID: string;
    REACT_APP_B2C_DOMAIN: string;
    REACT_APP_B2C_SIGNIN: string;
    REACT_APP_B2C_FORGOTPASS: string;
    REACT_APP_B2C_AUTHORITY_SIGNIN: string;
    REACT_APP_B2C_AUTHORITY_FORGOTPASS: string;
    REACT_APP_B2C_AUTHORITY_DOMAIN: string;
    REACT_APP_STRIPE_PUBLISHABLE_KEY: string;
    REACT_APP_APPINSIGHTS_KEY: string;
    REACT_APP_APPINSIGHTS_CONNECTION_STRING: string;
    REACT_APP_ENABLE_STT_DIAGNOSTICS: string;
    REACT_APP_ENABLE_ANDROID_NATIVE_RECORDER: string;
    REACT_APP_ENABLE_ANDROID_AUDIO_CONSTRAINTS: string;
    REACT_APP_ENABLE_ASSESSMENT_WAKE_LOCK: string;
}

export const Env: EnvironmentVariables = {
    REACT_APP_API_URL: process.env.REACT_APP_API_URL!,
    REACT_APP_BLOB_URL: process.env.REACT_APP_BLOB_URL!,
    REACT_APP_PRESENT_TARGETS_TIME: process.env.REACT_APP_PRESENT_TARGETS_TIME!,
    REACT_APP_CUED_RECALL_TIME: process.env.REACT_APP_CUED_RECALL_TIME!,
    REACT_APP_FREE_RECALL_TIME: process.env.REACT_APP_FREE_RECALL_TIME!,
    REACT_APP_FREE_RECALL_TIMEOUT: process.env.REACT_APP_FREE_RECALL_TIMEOUT!,
    REACT_APP_DELAY_TIME: process.env.REACT_APP_DELAY_TIME!,
    REACT_APP_ASSESSMENT_TIMEOUT: process.env.REACT_APP_ASSESSMENT_TIMEOUT!,
    REACT_APP_SHOW_TIMERS: process.env.REACT_APP_SHOW_TIMERS!,
    REACT_APP_SHOW_LOGS: process.env.REACT_APP_SHOW_LOGS!,
    REACT_APP_STT_BOOST: process.env.REACT_APP_STT_BOOST!,
    REACT_APP_STT_PT_TIMEOUT: process.env.REACT_APP_STT_PT_TIMEOUT!,
    REACT_APP_STT_FR_TIMEOUT: process.env.REACT_APP_STT_FR_TIMEOUT!,
    REACT_APP_STT_CR_TIMEOUT: process.env.REACT_APP_STT_CR_TIMEOUT!,
    REACT_APP_GOOGLE_STT_KEY: process.env.REACT_APP_GOOGLE_STT_KEY!,
    REACT_APP_AZURE_STT_KEY: process.env.REACT_APP_AZURE_STT_KEY!,
    REACT_APP_AZURE_STT_REGION: process.env.REACT_APP_AZURE_STT_REGION!,
    REACT_APP_B2C_CLIENT_ID: process.env.REACT_APP_B2C_CLIENT_ID!,
    REACT_APP_B2C_DOMAIN: process.env.REACT_APP_B2C_DOMAIN!,
    REACT_APP_B2C_SIGNIN: process.env.REACT_APP_B2C_SIGNIN!,
    REACT_APP_B2C_FORGOTPASS: process.env.REACT_APP_B2C_FORGOTPASS!,
    REACT_APP_B2C_AUTHORITY_SIGNIN: process.env.REACT_APP_B2C_AUTHORITY_SIGNIN!,
    REACT_APP_B2C_AUTHORITY_FORGOTPASS: process.env.REACT_APP_B2C_AUTHORITY_FORGOTPASS!,
    REACT_APP_B2C_AUTHORITY_DOMAIN: process.env.REACT_APP_B2C_AUTHORITY_DOMAIN!,
    REACT_APP_STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!,
    REACT_APP_APPINSIGHTS_KEY: process.env.REACT_APP_APPINSIGHTS_KEY!,
    REACT_APP_APPINSIGHTS_CONNECTION_STRING: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING!,
    REACT_APP_ENABLE_STT_DIAGNOSTICS: process.env.REACT_APP_ENABLE_STT_DIAGNOSTICS!,
    REACT_APP_ENABLE_ANDROID_NATIVE_RECORDER: process.env.REACT_APP_ENABLE_ANDROID_NATIVE_RECORDER!,
    REACT_APP_ENABLE_ANDROID_AUDIO_CONSTRAINTS: process.env.REACT_APP_ENABLE_ANDROID_AUDIO_CONSTRAINTS!,
    REACT_APP_ENABLE_ASSESSMENT_WAKE_LOCK: process.env.REACT_APP_ENABLE_ASSESSMENT_WAKE_LOCK!
};
